export default __webpack_public_path__ + "static/media/fsBg.dfe688c2.png";